import script from "./Confetti.vue?vue&type=script&setup=true&lang=ts"
export * from "./Confetti.vue?vue&type=script&setup=true&lang=ts"

import "./Confetti.vue?vue&type=style&index=0&id=3193c4f3&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3193c4f3"]])

export default __exports__